import { MaterialIcon } from '../MaterialIcon';

interface RoomCodeBadgeProps {
  code: string;
  round?: string;
}

export function RoomCodeBadge({ code, round }: RoomCodeBadgeProps) {
  return (
    <div className="hidden md:flex items-center gap-2 px-3 py-1 bg-surface-container-highest rounded-full border border-white/10">
      <span className="text-secondary font-bold font-label-bold text-label-bold">{code}</span>
      {round && (
        <>
          <span className="text-on-surface-variant/50">|</span>
          <span className="text-on-surface-variant font-label-bold text-label-bold">{round}</span>
        </>
      )}
    </div>
  );
}

export function TimerBadge({ seconds }: { seconds: number }) {
  return (
    <div className="flex items-center gap-2 text-error animate-pulse">
      <MaterialIcon name="timer" className="text-[20px]" />
      <span className="font-label-bold text-label-bold">{seconds}s</span>
    </div>
  );
}

interface StatusBadgeProps {
  text: string;
  variant?: 'primary' | 'secondary';
}

export function StatusBadge({ text, variant = 'primary' }: StatusBadgeProps) {
  const colors =
    variant === 'primary'
      ? 'bg-primary/10 border-primary/20 text-primary'
      : 'bg-secondary/10 border-secondary/20 text-secondary';

  return (
    <div className={`${colors} border backdrop-blur-md px-6 py-2 rounded-full flex items-center justify-center gap-3`}>
      <span className={`w-2 h-2 rounded-full ${variant === 'primary' ? 'bg-primary animate-ping' : 'bg-secondary animate-pulse'}`} />
      <span className="font-label-bold text-label-bold uppercase tracking-widest">{text}</span>
    </div>
  );
}

export function RoundStatus({ text }: { text: string }) {
  return <StatusBadge text={text} />;
}
